/**
 * Mcx Dialog Mobile v0.0.5
 * Copyright (C) 2018 mcx
 * https://github.com/code-mcx/mcx-dialog-mobile
 * Full path to library file: https://github.com/dxx/mcx-dialog-mobile/blob/master/dist/mcx-dialog.js
 */
(function (global, factory) {
    (typeof exports === 'object' && typeof module !== 'undefined')
        ? module.exports = factory()
        : (typeof define === 'function' && define.amd)
        ? define(factory)
        : (global.mcxDialog = factory());
}(this, (function () {
    'use strict';

    function addClass(e, c) {
        var newclass = e.className.split(" ");
        if (e.className === "") newclass = [];
        newclass.push(c);
        e.className = newclass.join(" ");
    };

    function getAnimationEndName(dom) {
        var cssAnimation = ["animation", "webkitAnimation"];
        var animationEnd = {
            "animation": "animationend",
            "webkitAnimation": "webkitAnimationEnd"
        };
        for (var i = 0; i < cssAnimation.length; i++) {
            if (dom.style[cssAnimation[i]] != undefined) {
                return animationEnd[cssAnimation[i]];
            }
        }
        return undefined;
    }

    var layer = {
        initOpen: function initOpen(dom, options) {
            var _this = this;

            var body = document.querySelector("body");
            var bg = document.createElement("div");
            addClass(bg, "sirion-dialog-bg");

            if (options.bottom) {
                bg.addEventListener("click", function () {
                    handleClose();
                });
            }

            body.appendChild(bg);
            body.appendChild(dom);

            var animationEndName = getAnimationEndName(dom);
            function handleClose() {
                if (SirionUtils.confirmCaptcha()) {
                    if (animationEndName) {
                        layer.close([bg]);
                        addClass(dom, options.closeAnimation);
                        dom.addEventListener(animationEndName, function () {
                            layer.close([dom]);
                        });
                    } else {
                        layer.close([bg, dom]);
                    }
                }else{
                    let sureButton = options?.btns.filter(op=>op.className.includes('dialog-sure-button'));
                    if(sureButton && sureButton.length) sureButton[0].classList.remove('disabled');
                }
            }

            //set button click event
            options.btns.forEach(function (btn, i) {
                if (i != 0 && i <= options.btns.length - 1) {
                    if (!options.bottom) {
                        btn.addEventListener("click", function () {
                            handleClose();
                        });
                    } else {
                        btn.addEventListener("click", function () {
                            handleClose();
                            options.btnClick(_this.getAttribute("i"));
                        });
                    }
                } else {
                    btn.addEventListener("click", () => {
                        if (animationEndName) {
                            layer.close([bg]);
                            addClass(dom, options.closeAnimation);
                            dom.addEventListener(animationEndName, function () {
                                layer.close([dom]);
                            });
                        } else {
                            layer.close([bg, dom]);
                        }
                    });
                }
            });

            let domHeight = dom?.offsetHeight;
            let domWidth = dom?.offsetWidth;
            
            if (window.syncHeight) {
                domHeight = dom.getBoundingClientRect().height;
                domWidth = dom.getBoundingClientRect().width;
            }

            if (!options.bottom && dom) {
                //set position
                dom.style.top = (document.getElementsByTagName('html')[0]?.getBoundingClientRect().height - domHeight) / 2 + "px";
                dom.style['inset-inline-start'] = (document.getElementsByTagName('html')[0]?.getBoundingClientRect().width - domWidth) / 2 + "px";
            }
            document.getElementById("loader-bar") && document.getElementById("loader-bar").setAttribute('class','animate');
            document.getElementById("captcha-input") && document.getElementById("captcha-input").focus();
            document.getElementById('hrefElemId') && document.getElementById('hrefElemId').addEventListener("click", function () {
                let body = document.querySelector("body");
                body.removeChild(document.querySelector(".sirion-dialog-bg"));
                body.removeChild(document.querySelector(".sirion-dialog"));
            });
            window.isPopupOpen = true;
        },
        close: function close(doms) {
            var body = document.querySelector("body");
            for (var i = 0; i < doms.length; i++) {
                if (body.contains(doms[i])) {
                    body.removeChild(doms[i]);
                }
            }
        }
    };

    var mcxDialog = {
        alert: function alert(str, heading, yesCb, noCb, yes, no, url, closeCallBack, rmvCloseBtn, isfirstTabSpecificEntity, hideLoader, hideBtn, sessionTimeout) {
            var popupClass = "sirionsucessPopup", crossBtn;

            heading = heading?.toLowerCase() || intl_msg[24168];

            if (heading == "notification") {
                heading = intl_msg[24153];
            }
            if (heading == "error") {
                heading = intl_msg[24167];
                popupClass = "sirionerrorPopup";
            }
            if (heading == "alert") {
                heading = intl_msg[24168];
            }
            if (heading == "confirmation") {
                heading = intl_msg[25772];
                popupClass = "sirionconfirmPopup";
            }
            if (heading == "message") {
                heading = intl_msg[24169];
            }
            if (heading == "novate"){
                heading = intl_msg[29999];
            }
            if (yesCb == "navigateTo") {
                crossBtn = "navigateTo";
            } else if (yesCb == 'refreshUrl') {
                crossBtn = "refreshUrl";
            } else if (yesCb == 'goToPreviousPage') {
                crossBtn = "goToPreviousPage";
            } else {
                crossBtn = "cancel";
            }

            var scope = $('ng-view').scope();

            if(!yes && !hideBtn)
                yes = intl_msg[24184];

            if (yes && yesCb) {
                var sureBtn = document.createElement("a");
                if (url) {
                    var fullUrl = appName + "#" + url;
                    if (url == "/listRenderer/list/273") {
                        fullUrl = "#/listRender/273";
                    } else if (url == "/listRenderer/list/271") {
                        fullUrl = "#/listRender/271";
                    }
                    sureBtn.href = fullUrl;

                } else if (isfirstTabSpecificEntity) {
                    sureBtn.href = "javascript:void(0)";
                    sureBtn.onclick = function () {
                        sureBtn.classList.add('disabled');
                        window.interval && window.clearInterval(interval);
                        window.history.back();
                    };
                }
                else if (str == 'Please configure workflow for Contract Template.') {
                    sureBtn.href = "#/listRender/273";
                } else if (str == 'Please configure workflow for Clause.') {
                    sureBtn.href = "#/listRender/271";
                } else {
                    sureBtn = document.createElement("div");
                    sureBtn.onclick = function () {
                        sureBtn.classList.add('disabled');
                        if (typeof yesCb !== 'function') {
                            if (yesCb.indexOf("(true)") > -1) {
                                var yesBtnString = yesCb.split("(")[0];
                                scope[yesBtnString](true);
                            } else {
                                if (commonUtil.checkForAnimationOnClose(scope.jsonApi))
                                    scope[yesCb](null, true);
                                else
                                    scope[yesCb]();
                            }
                        }else{
                            yesCb();
                        }
                        closeCallBack && closeCallBack();
                        window.interval && window.clearInterval(interval);
                    };
                }
                sureBtn.innerText = yes;
                addClass(sureBtn, "dialog-sure-button");
            }

            if (no && noCb) {
                var cancelBtn = document.createElement("div");
                cancelBtn.innerText = no;
                addClass(cancelBtn, "dialog-cancel-button");
                cancelBtn.onclick = function () {
                    scope[noCb]();
                };
            }

            if (yes && (typeof yesCb == "undefined" || !yesCb )) {
                var sureBtn = document.createElement("div");
                sureBtn.innerText = yes;
                addClass(sureBtn, "dialog-sure-button");
            }

            var loaderDiv = document.createElement("div");
            loaderDiv.setAttribute('id','progress_loader');
            var loaderBar = document.createElement("div");
            loaderBar.setAttribute('id','loader-bar');
            loaderDiv.appendChild(loaderBar);

            let obj = {str, heading, yesCb, noCb, yes, no, url, closeCallBack, rmvCloseBtn, isfirstTabSpecificEntity, crossBtn, popupClass, hideLoader};
            var opts = {};
            opts.btns = [];
            if(cancelBtn)
                opts.btns.push(cancelBtn);
            if (sureBtn && popupClass != "sirionerrorPopup") {
                window.clearInterval(interval);
                var strText = str.replace(/<[^>]+>/g, '');
                var charCeilValue = Math.ceil(strText.length * 60 / 1000);
                var count = charCeilValue < 6 ? 5 : charCeilValue;
                sessionTimeout && (count = 60);
                sureBtn.innerHTML = `${yes} (${count})`;
                interval = window.setInterval(() => {
                    count--;
                    if (count >= 0)
                        sureBtn.innerHTML = `${yes} (${count})`;
                    if (count == 0) {
                        if (isfirstTabSpecificEntity && !window.isOnShowpageViaPopup) {
                            window.history.back();
                        }else if(url){
                            window.location = url;
                        }else if(!sessionTimeout){
                            yesCb && ((typeof yesCb !== 'function') ? scope[yesCb]() : yesCb());
                        }
                        closeCallBack && closeCallBack();
                        !sessionTimeout && mcxDialog.close();
                        clearInterval(interval);
                    }
                }, 1000);
                // opts.loaderDiv = loaderDiv;
                opts.btns.push(sureBtn);
            } else if (sureBtn && !str.length < 300) {
                opts.btns.push(sureBtn);
            }
            if(!sureBtn && !hideLoader){
                window.clearInterval(interval);
                var count = 5;
                interval = window.setInterval(() => {
                    count--;
                    if (count == 0) {
                        mcxDialog.close();
                        clearInterval(interval);
                    }
                }, 1000);
                opts.loaderDiv = loaderDiv;
            }

            this.open(obj, opts);
        },
        confirm: function confirm(str, heading, yesCbFn, noCbFn, field, yesName, noName, rmvCloseBtn, type,_customClass,onlyYesButton) {

            const _heading = heading?.toLowerCase() || intl_msg[25772];
            //heading = heading?.toLowerCase() || intl_msg[25772];

            if (_heading == "confirmation")
                heading = intl_msg[25772] || 'CONFIRMATION';
            if (_heading == "warning")
                heading = intl_msg[29214];
            if (_heading == "are_you_sure")
                heading = intl_msg[6486];
            if (_heading == "publish")
                heading = intl_msg[24186];
            if (_heading == "notification")
                heading = intl_msg[24153];
            if (_heading == "error")
                heading = intl_msg[24167];
            if (_heading == "alert")
                heading = intl_msg[24168];
            if (_heading == "message")
                heading = intl_msg[24169];

            if(str?.indexOf("|||")){
                var t = str.split("|||");
                str = t[0];
            }
            if (window.entityURLdata && window.entityURLdata.indexOf("/contracttemplate/new") > -1 && yesCbFn && yesCbFn == "delFile") {
                //do nothing
            } else if (window.entityURLdata && ["/contracttemplate/clone", "/contracttemplate/new", "/clause/new", "/clause/clone", "/project/new"].find(path => window.entityURLdata.indexOf(path) > -1)) {
                var fieldJson = $.parseJSON(field);
                if (fieldJson.api && fieldJson.api.indexOf("listRenderer/list")) {
                    fieldJson.api = fieldJson.api.replace('listRenderer/list', 'listRender');
                }
                field = JSON.stringify(fieldJson);
            }

            var noCustomClass = _customClass ? _customClass.no : "";
            var yesCustomClass = _customClass ? _customClass.yes : "";

            var cancelBtn = document.createElement("div");
            addClass(cancelBtn, "dialog-cancel-button");
            addClass(cancelBtn, noCustomClass);

            var sureBtn = document.createElement("div");
            addClass(sureBtn, "dialog-sure-button");
            addClass(sureBtn, yesCustomClass);

            var yesLabel = yesName ? yesName : intl_msg[25815];
            var noLabel = noName ? noName : intl_msg[25816];


            var scope = $('ng-view').scope();
            if (field && field.indexOf(":") == -1) {
                sureBtn.innerText = yesLabel;
                cancelBtn.innerText = noLabel;
                sureBtn.onclick = function () {
                    sureBtn.classList.add('disabled');
                    if(typeof yesCbFn !== 'function' && !field)
                        scope[yesCbFn]();
                    else if(typeof yesCbFn !== 'function')
                        scope[yesCbFn](field.indexOf(":") > -1 ? JSON.parse(field) : field);
                    else
                        yesCbFn();
                };
                cancelBtn.onclick = function () {
                    if(typeof noCbFn !== 'function' && !field)
                        scope[noCbFn]();
                    else if(typeof noCbFn !== 'function')
                        scope[noCbFn](field.indexOf(":") > -1 ? JSON.parse(field) : field);
                    else
                        noCbFn();
                };
            } else {
                sureBtn.innerText = yesLabel;
                if (typeof onlyYesButton == "undefined") {
                    cancelBtn.innerText = noLabel;
                    cancelBtn.onclick = function () {
                        if(typeof noCbFn !== 'function' && !field)
                            scope[noCbFn]();
                        else if(typeof noCbFn !== 'function')
                            scope[noCbFn](JSON.parse(field));
                        else
                            noCbFn();
                    };
                }
                sureBtn.onclick = function () {
                    if(window.sessionStorage.getItem('raiserequestWFListUrl')){
                        window.sessionStorage.setItem('fromSirionDialogs', true)
                    }
                    sureBtn.classList.add('disabled');
                    if(typeof yesCbFn !== 'function' && !field)
                        scope[yesCbFn]();
                    else if(typeof yesCbFn !== 'function')
                        scope[yesCbFn](JSON.parse(field));
                    else
                        yesCbFn();
                };
            }

            var fieldJ = null;
            if ($.type(field) == 'string') {
                try {
                    fieldJ = JSON.parse(field);
                } catch (e) {
                    fieldJ = {};
                }
            }
            if (fieldJ && fieldJ.name && (fieldJ.name.toLowerCase() == "cancel" || fieldJ.name.toLowerCase() == "success") || (_.has(fieldJ, "properties.onClick.success") && fieldJ.properties.onClick.success == "closePopUp")) {
                var popupClass = " sirionconfirmPopup";
            } else if (_heading == "Publish") {
                var popupClass = " sirionconfirmPopup";
            }else {
                var popupClass = " sirionerrorPopup";
            }

            let obj = {str, heading, yesCbFn, noCbFn, field, yesName, noName, rmvCloseBtn, type, _customClass, onlyYesButton, popupClass, ...(noCbFn === 'resetCloneCLIState' && { crossBtn: 'resetCloneCLIState' })};
            let opts = {};
            opts.btns = [cancelBtn, sureBtn];
            this.open(obj, opts);
        },
        open: function open(obj, options) {
            var dialog = document.createElement("div");
            var dialogContent = document.createElement("div");

            addClass(dialog, "sirion-dialog");
            addClass(dialog, "animation-zoom-in");
            addClass(dialog, obj.popupClass);
            addClass(dialogContent, "dialog-content");

            var scope = $('ng-view').scope();
            if(scope){
                scope.mcxDialogObject = obj;
            }

            var header = {
                html: obj.rmvCloseBtn ? "<h3>{{title}}</h3><span class='dialog_header_close'></span>" :
                                        `<h3>{{title}}</h3><span class='dialog_header_close'><i onclick={{mcxDialog.close()}} class='icon-close' title=${intl_msg[24237]}></i></span>`,
                title: obj.heading
            };
            var headerSec = document.createElement("div");
            addClass(headerSec,"dialog-header");
            for (var key in header) {
                header.html = header.html.replace("{{" + key + "}}", header[key])
            }
            headerSec.innerHTML = header.html;
            dialog.appendChild(headerSec);

            dialogContent.innerHTML = obj.str;

            dialog.appendChild(dialogContent);

            var dialogFooter = document.createElement("div");
            addClass(dialogFooter, "dialog-footer");
            options.btns.forEach(function (btn, i) {
                dialogFooter.appendChild(btn);
            });
            dialog.appendChild(dialogFooter);
            if(options.loaderDiv)
                dialog.appendChild(options.loaderDiv);

            options.closeAnimation = "animation-zoom-out";

            layer.initOpen(dialog, options);
        },
        close: function close(){
            delete window.isPopupOpen;
            delete window.isOnShowpageViaPopup;
            var scope = $('ng-view').scope();
            if (scope?.mcxDialogObject?.crossBtn && scope[scope.mcxDialogObject.crossBtn])
                scope[scope.mcxDialogObject.crossBtn]();
            let elm = [];
            elm.push(document.querySelector(".sirion-dialog-bg"));
            elm.push(document.querySelector(".sirion-dialog"));
            if (!elm.includes(null)) {
                addClass(document.querySelector(".sirion-dialog"), "animation-zoom-out");
                setTimeout(() => {
                    var body = document.querySelector("body");
                    for (var i = 0; i < elm.length; i++) {
                        if (body.contains(elm[i])) {
                            body.removeChild(elm[i]);
                        }
                    }
                }, 200);
            }
            window.interval && window.clearInterval(interval);
        }
    };

    return mcxDialog;

})));
